import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutPropertiesLoose from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
var _excluded = ["component"],
  _excluded2 = ["activeClassName", "href", "noLinkStyle", "prefetch"],
  _excluded3 = ["beta", "children", "deprecated", "depth", "href", "icon", "legacy", "newFeature", "planned", "unstable", "linkProps", "onClick", "initiallyExpanded", "expandable", "plan", "subheader", "title", "topLevel"];
import * as React from 'react';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import { alpha, styled } from '@mui/material/styles';
import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { samePageLinkNavigation } from 'docs/src/modules/components/MarkdownLinks';
import { Link } from '@mui/docs/Link';
import standardNavIcons from './AppNavIcons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ItemBase(_ref) {
  var _ref$component = _ref.component,
    Component = _ref$component === void 0 ? 'div' : _ref$component,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Component, _extends({}, props));
}
var Item = styled(ItemBase, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'depth' && prop !== 'hasIcon' && prop !== 'subheader' && prop !== 'expandable';
  }
})(function (_ref2) {
  var theme = _ref2.theme;
  return [_extends({}, theme.typography.body2, _defineProperty(_defineProperty(_defineProperty({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    borderRadius: 6,
    color: "var(--_color, ".concat((theme.vars || theme).palette.text.secondary, ")"),
    outline: 0,
    width: '100%',
    padding: 6,
    justifyContent: 'flex-start',
    fontWeight: theme.typography.fontWeightSemiBold,
    transition: theme.transitions.create(['color', 'background-color'], {
      duration: theme.transitions.duration.shortest
    }),
    fontSize: theme.typography.pxToRem(14),
    textDecoration: 'none',
    paddingLeft: "calc(10px + (var(--_depth) + 1) * 13px - (var(--_expandable) * 21px))",
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      zIndex: 1,
      left: 9.5,
      height: '100%',
      width: 1,
      opacity: 0,
      background: (theme.vars || theme).palette.grey[100]
    },
    variants: [{
      props: function props(_ref3) {
        var depth = _ref3.depth;
        return depth === 0;
      },
      style: {
        '--_color': (theme.vars || theme).palette.text.primary
      }
    }, {
      props: function props(_ref4) {
        var depth = _ref4.depth;
        return depth !== 0;
      },
      style: {
        fontWeight: theme.typography.fontWeightMedium,
        '&::before': {
          opacity: 1
        }
      }
    }, {
      props: function props(_ref5) {
        var subheader = _ref5.subheader;
        return !subheader;
      },
      style: [{
        '&:hover': {
          color: (theme.vars || theme).palette.common.black,
          backgroundColor: (theme.vars || theme).palette.grey[50],
          '@media (hover: none)': {
            color: 'var(--_color)',
            backgroundColor: 'transparent'
          }
        }
      }, theme.applyDarkStyles({
        '&:hover': {
          color: '#fff',
          backgroundColor: alpha(theme.palette.primaryDark[700], 0.4),
          '@media (hover: none)': {
            color: 'var(--_color)',
            backgroundColor: 'transparent'
          }
        }
      })]
    }, {
      props: function props(_ref6) {
        var subheader = _ref6.subheader;
        return !!subheader;
      },
      style: [{
        '--_color': (theme.vars || theme).palette.text.tertiary,
        marginTop: theme.spacing(1),
        textTransform: 'uppercase',
        letterSpacing: '.1rem',
        fontWeight: theme.typography.fontWeightSemiBold,
        fontSize: theme.typography.pxToRem(11),
        '&::before': {
          content: '""',
          display: 'block',
          position: 'absolute',
          zIndex: 1,
          left: 9.5,
          height: '55%',
          top: 16,
          width: 1,
          opacity: 0,
          background: (theme.vars || theme).palette.grey[100]
        },
        '&::after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          zIndex: 5,
          left: 6,
          height: 8,
          width: 8,
          borderRadius: 2,
          opacity: 0,
          background: alpha(theme.palette.grey[50], 0.5),
          border: '1px solid',
          borderColor: (theme.vars || theme).palette.grey[200]
        }
      }, theme.applyDarkStyles({
        '&::before': {
          background: (theme.vars || theme).palette.primaryDark[700]
        },
        '&::after': {
          background: alpha(theme.palette.primaryDark[700], 0.8),
          borderColor: alpha(theme.palette.primaryDark[600], 0.6)
        }
      })]
    }, {
      props: function props(_ref7) {
        var depth = _ref7.depth,
          subheader = _ref7.subheader;
        return depth !== 0 && subheader;
      },
      style: {
        '&::after': {
          opacity: 1
        },
        '&::before': {
          opacity: 1
        }
      }
    }, {
      props: function props(_ref8) {
        var hasIcon = _ref8.hasIcon;
        return !!hasIcon;
      },
      style: {
        paddingLeft: 0
      }
    }],
    '&.app-drawer-active': {
      // To match browserUrlPreviewMarge
      scrollMarginBottom: 120,
      color: (theme.vars || theme).palette.primary[600],
      backgroundColor: (theme.vars || theme).palette.primary[50],
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary[100], 0.8),
        color: (theme.vars || theme).palette.primary[700],
        '@media (hover: none)': {
          backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.primary.mainChannel, " / ").concat(theme.vars.palette.action.selectedOpacity, ")") : alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
        }
      },
      '&::before': {
        background: (theme.vars || theme).palette.primary[400]
      }
    },
    '& .MuiChip-root': {
      marginTop: '2px'
    }
  }, theme.breakpoints.up('md'), {
    paddingTop: 4,
    paddingBottom: 4
  }), '& .ItemButtonIcon', {
    marginRight: '6px',
    color: (theme.vars || theme).palette.primary.main
  }), '&:hover .ItemButtonIcon', {
    color: (theme.vars || theme).palette.primary.light,
    '@media (hover: none)': {
      color: (theme.vars || theme).palette.primary.main
    }
  })), theme.applyDarkStyles({
    color: "var(--_color, ".concat((theme.vars || theme).palette.text.secondary, ")"),
    '&::before': {
      background: (theme.vars || theme).palette.primaryDark[700]
    },
    '&.app-drawer-active': {
      color: (theme.vars || theme).palette.primary[300],
      backgroundColor: (theme.vars || theme).palette.primaryDark[700],
      '&:hover': {
        backgroundColor: (theme.vars || theme).palette.primaryDark[600],
        color: (theme.vars || theme).palette.primary[200]
      },
      '&::before': {
        background: (theme.vars || theme).palette.primary[400]
      }
    }
  })];
});
var ItemButtonIcon = styled(KeyboardArrowRightRoundedIcon, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'open';
  }
})({
  fontSize: '1rem',
  '&&:last-child': {
    // overrides https://github.com/mui/material-ui/blob/ca7c5c63e64b6a7f55255981f1836a565927b56c/docs/src/modules/brandingTheme.ts#L757-L759
    marginLeft: 0
  },
  variants: [{
    props: {
      open: true
    },
    style: {
      transform: 'rotate(90deg)'
    }
  }]
});
var StyledLi = styled('li', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'depth';
  }
})(function (_ref9) {
  var theme = _ref9.theme;
  return {
    display: 'block',
    variants: [{
      props: {
        depth: 0
      },
      style: {
        padding: theme.spacing(1, '10px', 0, '10px')
      }
    }, {
      props: function props(_ref10) {
        var depth = _ref10.depth;
        return depth !== 0;
      },
      style: {
        padding: 0
      }
    }]
  };
});
export var sxChip = function sxChip(color) {
  return [function (theme) {
    return {
      ml: 1,
      fontSize: theme.typography.pxToRem(10),
      fontWeight: 'semiBold',
      textTransform: 'uppercase',
      letterSpacing: '.04rem',
      height: '16px',
      border: 1,
      borderColor: (theme.vars || theme).palette[color][300],
      bgcolor: alpha(theme.palette[color][100], 0.5),
      color: (theme.vars || theme).palette[color][900],
      '&:hover': {
        bgcolor: alpha(theme.palette[color][100], 0.5)
      },
      '& .MuiChip-label': {
        px: '4px'
      }
    };
  }, function (theme) {
    return theme.applyDarkStyles({
      borderColor: alpha(theme.palette[color][800], 0.5),
      bgcolor: alpha(theme.palette[color][900], 0.5),
      color: (theme.vars || theme).palette[color][300],
      '&:hover': {
        bgcolor: alpha(theme.palette[color][900], 0.5)
      }
    });
  }];
};
function DeadLink(props) {
  var activeClassName = props.activeClassName,
    href = props.href,
    noLinkStyle = props.noLinkStyle,
    prefetch = props.prefetch,
    other = _objectWithoutPropertiesLoose(props, _excluded2);
  return /*#__PURE__*/_jsx("div", _extends({}, other));
}
false ? void 0 : void 0;
export default function AppNavDrawerItem(props) {
  var _linkProps$style;
  var beta = props.beta,
    children = props.children,
    deprecated = props.deprecated,
    depth = props.depth,
    href = props.href,
    icon = props.icon,
    legacy = props.legacy,
    newFeature = props.newFeature,
    planned = props.planned,
    unstable = props.unstable,
    linkProps = props.linkProps,
    onClick = props.onClick,
    _props$initiallyExpan = props.initiallyExpanded,
    initiallyExpanded = _props$initiallyExpan === void 0 ? false : _props$initiallyExpan,
    _props$expandable = props.expandable,
    expandable = _props$expandable === void 0 ? false : _props$expandable,
    _props$plan = props.plan,
    plan = _props$plan === void 0 ? 'community' : _props$plan,
    subheader = props.subheader,
    title = props.title,
    _props$topLevel = props.topLevel,
    topLevel = _props$topLevel === void 0 ? false : _props$topLevel,
    other = _objectWithoutPropertiesLoose(props, _excluded3);
  var _React$useState = React.useState(initiallyExpanded),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var handleClick = function handleClick(event) {
    // Ignore click events meant for native link handling, for example open in new tab
    if (samePageLinkNavigation(event)) {
      return;
    }
    if (onClick) {
      onClick(event);
    }
    if (expandable) {
      event.preventDefault();
      setOpen(function (oldOpen) {
        return !oldOpen;
      });
    }
  };
  var IconComponent = typeof icon === 'string' ? standardNavIcons[icon] : icon;
  var hasIcon = !!IconComponent;
  var iconElement = hasIcon ? /*#__PURE__*/_jsx(Box, {
    component: "span",
    sx: {
      '& svg': {
        fontSize: function fontSize(theme) {
          return theme.typography.pxToRem(16.5);
        }
      },
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      marginRight: '6px'
    },
    children: /*#__PURE__*/_jsx(IconComponent, {
      fontSize: "small",
      color: "primary"
    })
  }) : null;
  return /*#__PURE__*/_jsxs(StyledLi, _extends({}, other, {
    depth: depth,
    children: [/*#__PURE__*/_jsxs(Item, _extends({
      component: subheader ? DeadLink : Link,
      depth: depth,
      hasIcon: hasIcon,
      href: href,
      prefetch: false,
      subheader: subheader,
      expandable: expandable,
      activeClassName: initiallyExpanded ? null : 'app-drawer-active',
      className: topLevel ? 'algolia-lvl0' : null,
      onClick: handleClick
    }, linkProps, {
      style: _extends({}, (_linkProps$style = linkProps == null ? void 0 : linkProps.style) != null ? _linkProps$style : {}, {
        '--_depth': depth,
        '--_expandable': expandable ? 1 : 0
      }),
      children: [iconElement, expandable && /*#__PURE__*/_jsx(ItemButtonIcon, {
        className: "ItemButtonIcon",
        open: open
      }), title, plan === 'pro' && /*#__PURE__*/_jsx("span", {
        className: "plan-pro",
        title: "Pro plan"
      }), plan === 'premium' && /*#__PURE__*/_jsx("span", {
        className: "plan-premium",
        title: "Premium plan"
      }), legacy && /*#__PURE__*/_jsx(Chip, {
        label: "Legacy",
        sx: sxChip('warning')
      }), newFeature && /*#__PURE__*/_jsx(Chip, {
        label: "New",
        sx: sxChip('success')
      }), planned && /*#__PURE__*/_jsx(Chip, {
        label: "Planned",
        sx: sxChip('grey')
      }), unstable && /*#__PURE__*/_jsx(Chip, {
        label: "Preview",
        sx: sxChip('primary')
      }), beta && /*#__PURE__*/_jsx(Chip, {
        label: "Beta",
        sx: sxChip('primary')
      }), deprecated && /*#__PURE__*/_jsx(Chip, {
        label: "Deprecated",
        sx: sxChip('warning')
      })]
    })), expandable ? /*#__PURE__*/_jsx(Collapse, {
      "in": open,
      timeout: "auto",
      unmountOnExit: true,
      children: children
    }) : children]
  }));
}
false ? void 0 : void 0;